import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SnackBarStoreAction } from "Store/SnackBar";
import {
  getBulkAttendance,
  updateAttendance,
  getAttendanceNa,
} from "../../../services/userServices";
import { useTranslation } from "react-i18next";
import BackdropComponent from "../../Spinner/Spinner";
import classes from "./Attendence.module.css";
import AsttButton from "../../AsttButton/AsttButton";
import AsttLightButton from "../../ASTTButtonLight/AsttButtonLight";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import { useNavigate } from "react-router-dom";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import LastUpdateTooltip from "../Helpers/LastUpdateTooltip";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import SnackBar from "../../SnackBar/SnackBar";
import { bulkEditStoreAction } from "../../../Store/BulkEdit";
import PropTypes from "prop-types";
import PowerSharpIcon from "@mui/icons-material/PowerSharp";
import Tooltip from "@mui/material/Tooltip";
import Grid from "@mui/material/Grid";
import applicationUsageLog from "../../../utils/applicationUsagesLog";
import { Box, Button } from "@mui/material";
import { CustomButton } from "components/RosterConfig/RosterConfigStyle";

const getFilteredData = (data, property, value) =>
  data.filter((itm) => itm[property] === value);

const AttendanceTableCell = ({
  title,
  naValues,
  state,
  count,
  name,
  onChange,
}) => (
  <TableCell
    className={classes.attendanceTableCell}
    align="center"
    sx={{ backgroundColor: "#f0f0f0" }}
  >
    <div>{title}</div>
    {naValues && <p className="redColor">N/A</p>}
    <div>
      <Checkbox
        type="checkbox"
        sx={{ color: "#ec6517" }}
        checked={state}
        onChange={(event) => onChange(event)}
        name={name}
      />
    </div>
    <div>{count}</div>
  </TableCell>
);

AttendanceTableCell.propTypes = {
  title: PropTypes.string,
  naValues: PropTypes.any,
  state: PropTypes.bool,
  count: PropTypes.number,
  name: PropTypes.string,
  onChange: PropTypes.func,
};

const Attendance = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation(["attendance"]);
  const [loading, setLoading] = useState(false);
  const classTraineeId = useSelector((state) => state.bulkEdit);
  const { classRequestId, classRosterId } = classTraineeId;
  const [attendanceData, setAttendanceData] = useState([]);

  const [filterData, setFilterData] = useState([]);
  const initialRender = useRef(true);
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const { filterStatus } = props;
  const [order, setOrder] = useState("ASC");
  const [allData, setAllData] = useState([]);
  const [totalActiveCount, setTotalActiveCount] = useState({
    total: 0,
    active: 0,
  });

  const [tci, setTci] = useState({
    state: false,
    count: 0,
  });
  const [tciRecovery, setTciRecovery] = useState({
    state: false,
    count: 0,
  });
  const [ttd, setTtd] = useState({
    state: false,
    count: 0,
  });
  const [ttdRecovery, setTtdRecovery] = useState({
    state: false,
    count: 0,
  });
  const [ttf, setTtf] = useState({
    state: false,
    count: 0,
  });
  const [productTraining, setProductTraining] = useState({
    state: false,
    count: 0,
  });
  const [nesting, setNesting] = useState({
    state: false,
    count: 0,
  });
  const [production, setProduction] = useState({
    state: false,
    count: 0,
  });

  const [naValues, setNaValues] = useState({});
  const [agentComments, setAgentComments] = useState("");
  const sorting = (col) => {
    if (order === "ASC") {
      const sorted = [...attendanceData].sort((a, b) =>
        a[col].toLowerCase() > b[col].toLowerCase() ? 1 : -1,
      );
      setAttendanceData(sorted);
      setOrder("DSC");
    }
    if (order === "DSC") {
      const sorted = [...attendanceData].sort((a, b) =>
        a[col].toLowerCase() < b[col].toLowerCase() ? 1 : -1,
      );
      setAttendanceData(sorted);
      setOrder("ASC");
    }
  };

  const fetchData = async () => {
    setLoading(true);
    let obj = {
      classTraineeIdList: classTraineeId.traineeDetails,
    };
    const response = await getBulkAttendance(obj);
    if (response.message === "Success") {
      setFilterData(response.data);
      setAllData(response.data);
      setLoading(false);
      dispatch(bulkEditStoreAction.setAttendanceData(response.data));
      dispatch(bulkEditStoreAction.setAttendanceAllData(response.data));
    } else {
      setSnack({
        open: true,
        message: "Failed to load data!",
        severity: "error",
      });
      setLoading(false);
    }
    if (props.resetStatus === true) {
      setFilterData(response.data);
      props.onChange();

      setAgentComments("");

      setTci({
        state: false,
        count: 0,
      });
      setTciRecovery({
        state: false,
        count: 0,
      });
      setTtd({
        state: false,
        count: 0,
      });
      setTtdRecovery({
        state: false,
        count: 0,
      });
      setTtf({
        state: false,
        count: 0,
      });
      setProductTraining({
        state: false,
        count: 0,
      });
      setNesting({
        state: false,
        count: 0,
      });
      setProduction({
        state: false,
        count: 0,
      });
    }
    if (response.data) {
      filtering(props.filterStatus, response.data);
    }
  };

  useEffect(() => {
    let cancelled = false;

    const initialize = async () => {
      try {
        await fetchData();

        if (cancelled) return;

        const response = await getAttendanceNa(props.roster);

        if (cancelled) return;

        if (response.status === true) {
          if (!cancelled) {
            setNaValues(response.data[0]);
          }
        }

        if (!cancelled) {
          applicationUsageLog(
            localStorage.getItem("User"),
            localStorage.getItem("EmailId"),
            "ASTT",
            "Attendance",
          );
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to initialize attendance:", error);
        }
      }
    };

    initialize();

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    let cancelled = false;

    const refreshData = async () => {
      if (props.resetStatus === true) {
        try {
          await fetchData();
        } catch (error) {
          if (!cancelled) {
            console.error("Failed to refresh data:", error);
          }
        }
      }
    };

    refreshData();

    return () => {
      cancelled = true;
    };
  }, [props.resetStatus]);

  const filtering = (filter, data) => {
    let filterData = [];

    if (filter === "ALL") {
      filterData = data;
    } else {
      filterData = data.filter((item) => item.TraineeStatus === filter);
    }

    setAttendanceData(filterData);
    initialCheck(filterData);
    props.closeLoader();
  };

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
    } else {
      setLoading(true);

      const timeout = setTimeout(() => {
        filtering(props.filterStatus, filterData);
        setLoading(false);
      }, 1000);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [props.filterStatus]);

  const initialCheck = (data) => {
    let activeCount = getFilteredData(data, "TraineeStatus", "Active");
    setTotalActiveCount({
      total: data.length,
      active: activeCount.length,
    });

    const attendedCounts = {
      AttendedTCIRecovery: "tciRecoveryCount",
      AttendedTPCLD: "tpcLdCount",
      AttendedTTF: "ttfCount",
      AttendedTechTest: "ttdBotCount",
      AttendedTechTestRecovery: "ttdRecoveryCount",
      AttendedTPCOG: "tpcOgCount",
      AttendedTPCTA: "tpcTACount",
      AttendedNesting: "nestigCount",
      AttendedProductTraining: "productTrainingCount",
      AttendedProduction: "productionCount",
      AttendedTCI: "tciCOunt",
    };
    const counts = Object.keys(attendedCounts).reduce((acc, key) => {
      acc[attendedCounts[key]] = data.filter((item) => item[key]).length;
      return acc;
    }, {});

    setNesting({ count: counts.nestigCount, state: false });
    setProductTraining({ state: false, count: counts.productTrainingCount });
    setProduction({ count: counts.productionCount, state: false });
    setTci({ count: counts.tciCOunt, state: false });
    setTciRecovery({ state: false, count: counts.tciRecoveryCount });
    setTtf({ state: false, count: counts.ttfCount });
    setTtd({ state: false, count: counts.ttdBotCount });
    setTtdRecovery({ count: counts.ttdRecoveryCount, state: false });
  };

  const setCountValues = (event, count, data) => {
    if (event === "AttendedNesting") {
      setNesting({
        count: count,
      });
    }
    if (event === "AttendedProductTraining") {
      setProductTraining({
        count: count,
      });
    }
    if (event === "AttendedProduction") {
      setProduction({
        count: count,
      });
    }
    if (event === "AttendedTCI") {
      setTci({
        count: count,
      });
    }
    if (event === "AttendedTCIRecovery") {
      setTciRecovery({
        count: count,
      });
    }

    if (event === "AttendedTTF") {
      setTtf({
        count: count,
      });
    }
    if (event === "AttendedTechTest") {
      setTtd({
        count: count,
      });
    }
    if (event === "AttendedTechTestRecovery") {
      setTtdRecovery({
        count: count,
      });
    }
  };

  const handleChangeChecked = (event, row, i) => {
    let trainee = attendanceData.map((item) => {
      if (
        item.OracleId === row.OracleId &&
        item.TraineeStatus === row.TraineeStatus
      ) {
        return {
          ...item,
          [event.target.name]: event.target.checked,
        };
      } else {
        return item;
      }
    });
    setAttendanceData(trainee);
    dispatch(bulkEditStoreAction.setAttendanceData(trainee));

    let data = filterData.map((item) => {
      if (
        item.OracleId === row.OracleId &&
        item.TraineeStatus === row.TraineeStatus
      ) {
        return {
          ...item,
          [event.target.name]: event.target.checked,
        };
      } else {
        return item;
      }
    });

    setFilterData(data);

    let count = 0;
    for (const value of trainee) {
      if (value[event.target.name]) {
        count = count + 1;
      }
    }

    setCountValues(event.target.name, count, trainee);
  };

  const validateAttendanceProperty = (item) => (item ? "true" : "false");

  const navigateBack = () => {
    navigate(
      `/home/searchrosters?classRequestId=${classRequestId}&classRosterId=${classRosterId}`,
    );
  };
  const createData = () =>
    attendanceData.map((itm) => ({
      classTraineeId: itm.ClassTraineeId,
      agentComments: itm.AgentComments,
      attendedNesting: validateAttendanceProperty(itm.AttendedNesting),
      attendedProduction: validateAttendanceProperty(itm.AttendedProduction),
      attendedProductTraining: validateAttendanceProperty(
        itm.AttendedProductTraining,
      ),
      attendedTCI: validateAttendanceProperty(itm.AttendedTCI),
      attendedTCIRecovery: validateAttendanceProperty(itm.AttendedTCIRecovery),
      attendedTechTest: validateAttendanceProperty(itm.AttendedTechTest),
      attendedTechTestRecovery: validateAttendanceProperty(
        itm.AttendedTechTestRecovery,
      ),
      attendedTTF: validateAttendanceProperty(itm.AttendedTTF),
      modifiedBy: localStorage.getItem("User"),
    }));

  const saveCloseHandler = async () => {
    setLoading(true);
    let data = createData();
    let update = await updateAttendance(data);
    if (update.message === "Success") {
      const obj = {
        open: true,
        message: "Saved Succesfully !!",
        severity: "success",
      };
      dispatch(bulkEditStoreAction.setPreviousTabName(""));
      dispatch(SnackBarStoreAction.updateSnack(obj));
      navigateBack();
    } else {
      setSnack({
        open: true,
        message: "Failed to Save",
        severity: "error",
      });
    }

    setLoading(false);
  };
  const saveAttendance = async () => {
    setLoading(true);
    let data = createData();
    let update = await updateAttendance(data);
    if (update.message === "Success") {
      setSnack({
        open: true,
        message: "Saved Succesfully",
        severity: "success",
      });
      setAgentComments("");
      setAllData(filterData);
      fetchData();
    } else {
      setSnack({
        open: true,
        message: "Failed to Save",
        severity: "error",
      });
    }
    setLoading(false);
  };

  const snackReset = () => {
    setSnack({
      open: false,
      message: "",
      severity: "",
    });
  };

  const handleTraineeStatusCheck = (filterStatus, key, item, initial) =>
    item.TraineeStatus === filterStatus ? initial[key] : item[key];

  const findInitialData = (oracleId) =>
    allData.find((data) => data.OracleId === oracleId);

  const handleTextAll = (event, key) => {
    const isEmpty = event.target.value === "";
    const isFilterAll = filterStatus === "ALL";
    let newData;
    let newAttendanceData;

    if (isEmpty) {
      newData = filterData
        .map((item) => {
          const initial = findInitialData(item.OracleId);
          if (!initial) return null;

          return {
            ...item,
            [key]: isFilterAll
              ? initial[key]
              : handleTraineeStatusCheck(filterStatus, key, item, initial),
          };
        })
        .filter(Boolean);

      newAttendanceData = attendanceData
        .map((item) => {
          const initial = findInitialData(item.OracleId);
          if (!initial) return null;

          return {
            ...item,
            [key]: initial[key],
          };
        })
        .filter(Boolean);
    } else {
      newData = filterData.map((item) =>
        isFilterAll || filterStatus === item.TraineeStatus
          ? { ...item, [key]: event.target.value }
          : { ...item },
      );

      newAttendanceData = attendanceData.map((item) => ({
        ...item,
        [key]: event.target.value,
      }));
    }
    setAttendanceData(newAttendanceData);
    dispatch(bulkEditStoreAction.setAttendanceData(newAttendanceData));
    setFilterData(newData);
  };

  const handleIndividualText = (event, row, key) => {
    let data = filterData.map((item) => {
      if (
        item.OracleId === row.OracleId &&
        item.TraineeStatus === row.TraineeStatus
      ) {
        return {
          ...item,
          [key]: event.target.value,
        };
      } else {
        return item;
      }
    });
    let trainee = attendanceData.map((item) => {
      if (
        item.OracleId === row.OracleId &&
        item.TraineeStatus === row.TraineeStatus
      ) {
        return {
          ...item,
          [key]: event.target.value === "" ? null : event.target.value,
        };
      } else {
        return item;
      }
    });
    setAttendanceData(trainee);
    setFilterData(data);
    dispatch(bulkEditStoreAction.setAttendanceData(trainee));
  };

  const updateAttendanceData = (key, value) => {
    if (value) {
      const updatedData = attendanceData.map((item) => ({
        ...item,
        [key]: value,
      }));
      setAttendanceData(updatedData);
      dispatch(bulkEditStoreAction.setAttendanceData(updatedData));
    } else {
      let oldAttendenceData = attendanceData.map((item) => {
        let initialData = findInitialData(item.OracleId);
        return {
          ...item,
          [key]: initialData[key],
        };
      });
      setAttendanceData(oldAttendenceData);
      dispatch(bulkEditStoreAction.setAttendanceData(oldAttendenceData));
    }
  };

  const updateFilterData = (key, value) => {
    const updatedData = filterData.map((item) => {
      if (
        props.filterStatus === "ALL" ||
        props.filterStatus === item.TraineeStatus
      ) {
        return {
          ...item,
          [key]: value,
        };
      } else {
        return {
          ...item,
        };
      }
    });
    setFilterData(updatedData);
  };

  const handleCheckChangeAll = (event) => {
    const updateCount = (key, checked) => {
      const count = attendanceData.filter(
        (item) => item[key] === checked,
      ).length;
      switch (key) {
        case "AttendedNesting":
          setNesting({ state: checked, count });
          break;
        case "AttendedProductTraining":
          setProductTraining({ state: checked, count });
          break;
        case "AttendedProduction":
          setProduction({ state: checked, count });
          break;
        case "AttendedTCI":
          setTci({ state: checked, count });
          break;
        case "AttendedTCIRecovery":
          setTciRecovery({ state: checked, count });
          break;
        case "AttendedTTF":
          setTtf({ state: checked, count });
          break;
        case "AttendedTechTest":
          setTtd({ state: checked, count });
          break;
        case "AttendedTechTestRecovery":
          setTtdRecovery({ state: checked, count });
          break;
        default:
          break;
      }
    };

    if (event.target.checked) {
      updateAttendanceData(event.target.name, true);
      updateFilterData(event.target.name, true);
    } else {
      updateAttendanceData(event.target.name, event.target.checked);
      updateFilterData(event.target.name, event.target.checked);
    }

    updateCount(event.target.name, event.target.checked);
  };

  const renderTextCell = (oracleId, name, traineeStatus, isInactive) => (
    <Grid item xs={0.6} align="center">
      <p className={isInactive ? "text-decoration-line-bulk" : null}>
        {name}
        <br></br>
        {oracleId}
      </p>
      {isInactive && <p className="redColor">{traineeStatus}</p>}
    </Grid>
  );

  return (
    <div>
      {loading && <BackdropComponent />}
      {attendanceData.length > 0 && (
        <>
          <div>
            {/* Table Container */}
            <TableContainer className={classes.container} component={Paper}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {/* Table Headers */}
                    <TableCell
                      className={"text-center align-center"}
                      align="center"
                      sx={{ backgroundColor: "#f0f0f0" }}
                      onClick={() => sorting("Name")}
                    >
                      <div>
                        <span>{t("name")}</span>
                        <Box sx={{ display: "inline-block" }}>
                          {" "}
                          <ArrowUpwardIcon
                            sx={{ fontSize: 18, color: "#ED6417" }}
                          />{" "}
                          <ArrowDownwardIcon
                            sx={{ fontSize: 18, color: "#ED6417" }}
                          />
                        </Box>
                        <div className="orangeColor">
                          Total : {totalActiveCount.total} Active :
                          {totalActiveCount.active}{" "}
                        </div>
                      </div>
                    </TableCell>
                    <TableCell
                      className={"text-center align-center"}
                      align="center"
                      sx={{ backgroundColor: "#f0f0f0", padding: 5 }}
                    >
                      <div>{t("AgentComments")}</div>
                      <p className="redColor">
                        (Specific to this Employee OracleID)
                      </p>
                      <div>
                        <textarea
                          value={agentComments}
                          name="wave"
                          id="EmployeeComment"
                          type="text"
                          placeholder="Max 4000 characters allowed"
                          className={classes.inputContainer}
                          maxLength={4000}
                          onChange={(e) => {
                            setAgentComments(e.target.value);
                            handleTextAll(e, "AgentComments");
                          }}
                        ></textarea>
                      </div>
                    </TableCell>
                    {/* Attendance Table Cells */}
                    <AttendanceTableCell
                      title={t("TCI")}
                      naValues={naValues.TCINA}
                      state={tci.state}
                      count={tci.count}
                      name="AttendedTCI"
                      onChange={(event) => handleCheckChangeAll(event)}
                    />
                    <AttendanceTableCell
                      title={t("TCIRecovery")}
                      naValues={naValues.TCIRecoveryNA}
                      state={tciRecovery.state}
                      count={tciRecovery.count}
                      name="AttendedTCIRecovery"
                      onChange={(event) => handleCheckChangeAll(event)}
                    />
                    <AttendanceTableCell
                      title={t("TTD/BOT")}
                      naValues={naValues.TechTestNA}
                      state={ttd.state}
                      count={ttd.count}
                      name="AttendedTechTest"
                      onChange={(event) => handleCheckChangeAll(event)}
                    />
                    <AttendanceTableCell
                      title={t("TTDRecovery")}
                      naValues={naValues.TechTestRecoveryNA}
                      state={ttdRecovery.state}
                      count={ttdRecovery.count}
                      name="AttendedTechTestRecovery"
                      onChange={(event) => handleCheckChangeAll(event)}
                    />
                    <AttendanceTableCell
                      title={t("TTF")}
                      naValues={naValues.TTFNA}
                      state={ttf.state}
                      count={ttf.count}
                      name="AttendedTTF"
                      onChange={(event) => handleCheckChangeAll(event)}
                    />
                    <AttendanceTableCell
                      title={t("ProductTraining")}
                      state={productTraining.state}
                      count={productTraining.count}
                      name="AttendedProductTraining"
                      onChange={(event) => handleCheckChangeAll(event)}
                    />
                    <AttendanceTableCell
                      title={t("Nesting")}
                      naValues={naValues.NestingNA}
                      state={nesting.state}
                      count={nesting.count}
                      name="AttendedNesting"
                      onChange={(event) => handleCheckChangeAll(event)}
                    />
                    <AttendanceTableCell
                      title={t("Production")}
                      state={production.state}
                      count={production.count}
                      name="AttendedProduction"
                      onChange={(event) => handleCheckChangeAll(event)}
                    />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* Table Rows */}
                  {attendanceData.map((row, i) => {
                    const rowKey = `${row.OracleId}-${i}`;
                    return (
                      <TableRow key={rowKey}>
                        <TableCell align="center">
                          {/* Individual Row Cells */}
                          <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            columns={1}
                            alignItems="center"
                            spacing={0}
                          >
                            {renderTextCell(
                              row.OracleId,
                              row.Name,
                              row.TraineeStatus,
                              row.TraineeStatus !== "Active",
                            )}
                            {row.TTECRegistrationStatus ? (
                              <Grid item xs={0.1}>
                                <Tooltip title="TTEConnect: Registered">
                                  <PowerSharpIcon
                                    placeholder="TTEConnect: Registered"
                                    sx={{ color: "#69DE00" }}
                                  />
                                </Tooltip>
                              </Grid>
                            ) : (
                              <Grid item xs={0.1}></Grid>
                            )}
                          </Grid>
                        </TableCell>
                        <TableCell align="center">
                          <LastUpdateTooltip
                            AgentCommentsModifiedDate={
                              row.AgentCommentsModifiedDate
                            }
                            AgentCommentsModifiedBy={
                              row.AgentCommentsModifiedBy
                            }
                          >
                            <textarea
                              value={row.AgentComments ? row.AgentComments : ""}
                              className={classes.inputContainer}
                              maxLength={4000}
                              placeholder="Max 4000 characters allowed"
                              onChange={(e) =>
                                handleIndividualText(e, row, "AgentComments")
                              }
                            ></textarea>
                          </LastUpdateTooltip>
                        </TableCell>
                        {/* Other Cells */}
                        <TableCell align="center">
                          <Checkbox
                            type="checkbox"
                            sx={{ color: "#ec6517" }}
                            checked={row.AttendedTCI}
                            name="AttendedTCI"
                            onChange={(event) =>
                              handleChangeChecked(event, row, i)
                            }
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Checkbox
                            type="checkbox"
                            checked={row.AttendedTCIRecovery}
                            name="AttendedTCIRecovery"
                            sx={{ color: "#ec6517" }}
                            onChange={(event) =>
                              handleChangeChecked(event, row, i)
                            }
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Checkbox
                            type="checkbox"
                            sx={{ color: "#ec6517" }}
                            checked={row.AttendedTechTest}
                            name="AttendedTechTest"
                            onChange={(event) =>
                              handleChangeChecked(event, row, i)
                            }
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Checkbox
                            type="checkbox"
                            sx={{ color: "#ec6517" }}
                            checked={row.AttendedTechTestRecovery}
                            name="AttendedTechTestRecovery"
                            onChange={(event) =>
                              handleChangeChecked(event, row, i)
                            }
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Checkbox
                            type="checkbox"
                            sx={{ color: "#ec6517" }}
                            checked={row.AttendedTTF}
                            name="AttendedTTF"
                            onChange={(event) =>
                              handleChangeChecked(event, row, i)
                            }
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Checkbox
                            type="checkbox"
                            sx={{ color: "#ec6517" }}
                            checked={row.AttendedProductTraining}
                            name="AttendedProductTraining"
                            onChange={(event) =>
                              handleChangeChecked(event, row, i)
                            }
                          />
                        </TableCell>

                        <TableCell align="center">
                          <Checkbox
                            type="checkbox"
                            checked={row.AttendedNesting}
                            name="AttendedNesting"
                            sx={{ color: "#ec6517" }}
                            onChange={(event) =>
                              handleChangeChecked(event, row, i)
                            }
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Checkbox
                            type="checkbox"
                            sx={{ color: "#ec6517" }}
                            checked={row.AttendedProduction}
                            name="AttendedProduction"
                            onChange={(event) =>
                              handleChangeChecked(event, row, i)
                            }
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          {/* SnackBar Component */}
          <SnackBar snack={snack} snackReset={snackReset}></SnackBar>
          {/* Buttons */}
          <div className={classes.buttonContainer} style={{ overflow: "auto" }}>
            <AsttLightButton
              style={{
                backgroundColor: "#3299ff",
                color: "white",
                position: "fixed",
                fontSize: 13,
                bottom: 0,
                left: 10,
                width: 100,
                height: "3.3%",
                marginTop: 10,
                padding: 3,
                cursor: "pointer",
                border: "none",
              }}
              onClick={(e) => saveCloseHandler()}
            >
              {t("SAVE+CLOSE")}
            </AsttLightButton>
            <AsttButton
              buttonClass={classes.asttButton}
              onClick={(e) => saveAttendance()}
            >
              {t("SAVE")}
            </AsttButton>
            <AsttLightButton
              style={{
                backgroundColor: "#3299ff",
                color: "white",
                position: "Fixed",
                fontSize: 14,
                bottom: 0,
                left: 220,
                width: 100,
                height: "3.3%",
                padding: 3,
                cursor: "pointer",
                border: "none",
              }}
              onClick={navigateBack}
            >
              {t("CANCEL")}
            </AsttLightButton>
          </div>
        </>
      )}
    </div>
  );
};

Attendance.propTypes = {
  filterStatus: PropTypes.string,
  roster: PropTypes.string,
  closeLoader: PropTypes.func,
  resetStatus: PropTypes.bool,
  onChange: PropTypes.func,
};

export default Attendance;
